const listeners = new Map()
export const projectScope = (tenantId, projectId) => JSON.stringify([tenantId, projectId])

export function publishProjectChange(scope) {
  for (const listener of listeners.get(scope) || []) listener()
}

export function subscribeProjectChange(scope, listener) {
  if (!listeners.has(scope)) listeners.set(scope, new Set())
  listeners.get(scope).add(listener)
  return () => {
    const scoped = listeners.get(scope)
    scoped?.delete(listener)
    if (!scoped?.size) listeners.delete(scope)
  }
}
